import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  styles: {
    global: {
      body: {
        fontFamily: 'Poppins',
        fontWeight: '400',
        fontSize: '16px',
        overflowX: 'hidden'
      },
      ".rich-editor": {
        h1: {
          fontSize: "2em",
          fontWeight: '600' || 'bold',
          margin: '25px 0'
        },
        h2: {
          fontSize: "1.5em",
          fontWeight: 'bold',
          margin: '25px 0'
        },
        h3: {
          fontSize: "1.17em",
          fontWeight: '600' || 'bold',
          margin: '25px 0'
        },
        h4: {
          fontSize: "1em",
          fontWeight: '600' || 'bold',
          margin: '25px 0'

        },
        h5: {
          fontSize: "0.83em",
          fontWeight: 'bold',
          margin: '25px 0'
        },
        h6: {
          fontSize: "0.67em",
          fontWeight: 'bold',
          margin: '25px 0'

        },
        a: {
          color: "blue.600",
          _hover: {
            textDecoration: "underline",
          },
        }
      },
    },
  },
})


export default theme;




